import React from "react";
//#region redux
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store";
import { ThunkDispatch } from "redux-thunk";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { Navigate } from "react-router-dom";
import { hideEULA } from "store/actions/authActions";
//#endregion
//#region components
import { BreadCrumb, PageLayouts } from "components/common";
import { Grid } from "@mui/material";
import EULAContent from "./content";
import EULAFooter from "./footer";
import EULAHeader from "./header";
import { LoginContainer } from "components/login";
import { useUserService } from "serviceHooks";
//#endregion
import { AuthHelper, LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const EULAView: React.FC = (props) => {
  const userService = useUserService();
  const { isAuthenticated } = useSelector((store: AppState) => ({
    isAuthenticated: store.auth.isAuthorized,
  }));

  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const showEULA = useSelector((state: AppState) => state.auth.loggedInUser.unsignedEula);
  const canSuspendEula = useSelector((state: AppState) => state.auth.loggedInUser.canSuspendEula);

  const onClose = () => {
    userService.suspendEulaSigning().then(() => {
      dispatch(hideEULA());
    });
  };

  return AuthHelper.authenticate() || isAuthenticated ? (
    !showEULA ? (
      <Navigate to="/" replace />
    ) : (
      <PageLayouts.EntityFullScreen
        entityKey={`eula`}
        id={0}
        navigation={
          <BreadCrumb
            prevItems={[{ text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Approve) }]}
            current={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Eula.TermsOfUse)}
          />
        }
        closeDialog={onClose}
        hideCloseButton={!canSuspendEula}
      >
        <Grid container justifyContent="center">
          <Grid container item lg={8} rowSpacing={2}>
            <Grid item>
              <EULAHeader />
            </Grid>
            <Grid item className={cssExports.eulaContentContainer}>
              <EULAContent />
            </Grid>
            <EULAFooter />
          </Grid>
        </Grid>
      </PageLayouts.EntityFullScreen>
    )
  ) : (
    <LoginContainer />
  );
};

export default EULAView;
